import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import "./style.css";
import Support from "./views/support";
import Signup from "./views/signup";
import TermsOfService from "./views/terms-of-service";
import Business from "./views/business";
import Partner from "./views/partner";
import Merchant from "./views/merchant";
import Page from "./views/page"; // Assume this is your 404 page
import CashOverSDK from "./views/cash-over-sdk";
import Home from "./views/home";
import Blog from "./views/blog";
import FAQ from "./views/faq";
import Pay from "./views/pay";
import ScrollToTop from "./components/scroll-to-top";
import Operate from "./views/operate";
import Qr from "./views/qr";

const App = () => {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/operate" element={<Operate />} />
        <Route path="/pay" element={<Pay />} />
        <Route path="/support" element={<Support />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/business" element={<Business />} />
        <Route path="/partner" element={<Partner />} />
        <Route path="/merchant" element={<Merchant />} />
        <Route path="/cash-over-sdk" element={<CashOverSDK />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/qr" element={<Qr />} />
        <Route path="*" element={<Page />} /> {/* Catch-all route */}
      </Routes>
    </Router>
  );
};
ReactDOM.render(<App />, document.getElementById("app"));
